import { c as _c } from "react/compiler-runtime";
import { Chip, Flex, ItemAvatar, ItemContent, ItemDescription, ItemTitle, QuantityBadge, TextOverflowTooltip } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { Item } from "../Item";
export const ReceiptRowItemDisplay = t0 => {
  const $ = _c(22);
  const {
    imageUrl,
    title,
    quantity: t1,
    description,
    extra,
    marketplace
  } = t0;
  const quantity = t1 === undefined ? 1 : t1;
  const t = useTranslations("ReceiptRowItemDisplay");
  let t2;
  if ($[0] !== imageUrl) {
    t2 = <ItemAvatar className="rounded" size={48} src={imageUrl} />;
    $[0] = imageUrl;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <TextOverflowTooltip><ItemTitle>{title}</ItemTitle></TextOverflowTooltip>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== quantity) {
    t4 = quantity > 1 ? <QuantityBadge>{quantity}</QuantityBadge> : null;
    $[4] = quantity;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== marketplace || $[7] !== t) {
    t5 = marketplace && marketplace !== "opensea" ? <Chip>{t("noChestProgress")}</Chip> : null;
    $[6] = marketplace;
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== extra || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <Flex className="items-center gap-2">{t3}{t4}{t5}{extra}</Flex>;
    $[9] = extra;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== description) {
    t7 = description ? <ItemDescription className="mt-1 whitespace-nowrap">{description}</ItemDescription> : null;
    $[14] = description;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <ItemContent>{t6}{t7}</ItemContent>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t2 || $[20] !== t8) {
    t9 = <Item variant="unstyled">{t2}{t8}</Item>;
    $[19] = t2;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};